module.exports = __webpack_public_path__ + "static/media/manual3.883151eb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/manual3.pdf
// module id = 770
// module chunks = 0